import * as React from 'react';

interface ISlideoutHeaderCaptionProps {
  icon: React.ReactNode;
  children: React.ReactNode;
}

const SlideoutHeaderCaption = ({ icon, children }: ISlideoutHeaderCaptionProps) => {
  return (
    <div className="text-secondary_on-brand flex items-center gap-2 font-semibold">
      {icon}
      {children}
    </div>
  );
};

export default SlideoutHeaderCaption;
